/* RESPONSIBLE TEAM: team-inbox-experience */
import Route from '@ember/routing/route';

export default class WelcomeHelpdeskRoute extends Route {}
